var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 31.3,
  width: 38,
  height: 1.4,
  rx: 0.7,
  fill: "#c3ccd2"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 12.8,
  y: 12.9,
  width: 7.6,
  height: 2,
  rx: 1,
  fill: "#3f4a54"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 13.4,
  y: 13.3,
  width: 3,
  height: 1.2,
  rx: 0.4,
  fill: "#f2c14e"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 16.8,
  y: 13.3,
  width: 3,
  height: 1.2,
  rx: 0.4,
  fill: "#5a8fd8"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 9.5,
  y: 14.5,
  width: 27,
  height: 13.5,
  rx: 2.5,
  fill: "#dfe6ec"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 9.5,
  y: 23,
  width: 27,
  height: 2,
  fill: "#3f4a54"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 16.5,
  width: 6,
  height: 5,
  rx: 1,
  fill: "#8fb6c9"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 19,
  y: 16.5,
  width: 5.5,
  height: 5,
  rx: 1,
  fill: "#8fb6c9"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m30 15.8c1.8 0.7 2.9 0.7 2.9 0.7v2.7c0 2-1.3 3.3-2.9 4-1.6-0.7-2.9-2-2.9-4v-2.7s1.1 0 2.9-0.7z",
  fill: "#23967f"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m28.8 19 0.9 0.9 1.7-1.7",
  fill: "none",
  stroke: "#ffffff",
  strokeWidth: 0.9,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 15.5,
  cy: 28.5,
  r: 3,
  fill: "#333a40"
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 15.5,
  cy: 28.5,
  r: 1.2,
  fill: "#9aa7b0"
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 28.5,
  r: 3,
  fill: "#333a40"
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 28.5,
  r: 1.2,
  fill: "#9aa7b0"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m38.5 17.5h4",
  fill: "none",
  stroke: "#9fb3c8",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "m39.5 21.5h4",
  fill: "none",
  stroke: "#9fb3c8",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "m38.5 25.5h4",
  fill: "none",
  stroke: "#9fb3c8",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

function SvgSecurityVanEscort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityVanEscort);
export default __webpack_public_path__ + "static/media/security-van-escort.930910acd21e4bc5110453efa77d10b3.svg";
export { ForwardRef as ReactComponent };